import * as Yup from 'yup';

/**
 * Opções padronizadas de combustível — evita entradas livres inconsistentes
 * (ex.: "FLEX", "flex", "HIBRIDEX") no cadastro de veículos.
 */
export const FUEL_OPTIONS = [
  { value: 'Flex', label: 'Flex' },
  { value: 'Gasolina', label: 'Gasolina' },
  { value: 'Etanol', label: 'Etanol' },
  { value: 'Diesel', label: 'Diesel' },
  { value: 'Diesel S-10', label: 'Diesel S-10' },
  { value: 'GNV', label: 'GNV' },
  { value: 'Híbrido', label: 'Híbrido' },
  { value: 'Elétrico', label: 'Elétrico' },
];

/**
 * Placa no padrão Mercosul (ABC1D23) ou no padrão antigo (ABC1234),
 * com hífen opcional. A validação é feita sobre o valor em maiúsculas.
 */
export const PLATE_REGEX = /^[A-Z]{3}-?\d[A-Z0-9]\d{2}$/;

/**
 * Aceita "AAAA" (ano) ou "AAAA/AAAA" (ano/modelo), com cada ano entre 1980 e o
 * próximo ano. Bloqueia valores sem sentido como "2077" ou textos aleatórios.
 */
export function isValidYear(value?: string): boolean {
  if (!value) return false;
  const parts = value.split('/').map(part => part.trim());
  if (parts.length < 1 || parts.length > 2) return false;
  const maxYear = new Date().getFullYear() + 1;
  return parts.every(
    part =>
      /^\d{4}$/.test(part) && Number(part) >= 1980 && Number(part) <= maxYear,
  );
}

export const vehicleSchema = Yup.object().shape({
  name: Yup.string().trim().required('Nome do veículo é obrigatório'),
  plate: Yup.string()
    .trim()
    .uppercase()
    .required('Placa é obrigatória')
    .matches(PLATE_REGEX, 'Placa inválida (ex.: ABC1D23 ou ABC1234)'),
  year: Yup.string()
    .required('Ano é obrigatório')
    .test('valid-year', 'Ano inválido (use AAAA ou AAAA/AAAA)', isValidYear),
  fuel: Yup.string().required('Selecione o tipo de combustível'),
  km: Yup.number()
    .transform((current, original) => (original === '' ? undefined : current))
    .typeError('Quilometragem deve ser um número')
    .required('Quilometragem é obrigatória')
    .min(0, 'Quilometragem não pode ser negativa'),
  observations: Yup.string().nullable(),
});
